import { Icon } from "@/components/icons/Icon";
import type { FC } from "react";
import { DownloadWithProgressButton } from "./DownloadWithProgressButton";

interface OptionsTableChecksProps {
  selectedIds: number[];
  setSelectedIds: (ids: number[]) => void;
}

const OptionsTableChecks: FC<OptionsTableChecksProps> = ({
  selectedIds,
  setSelectedIds,
}) => {
  return (
    <tr data-testid="OptionsTableChecks" key={`checkbox-options`}>
      <td className="px-3 py-2 border-b border-b-ib-gray-lightest" colSpan={9}>
        <div className="bg-ib-red-main w-full py-4 px-6 flex text-white justify-between rounded-md text-xs">
          <div className="flex items-center gap-4">
            <DownloadWithProgressButton selectedIds={selectedIds} />
          </div>
          <div className="flex gap-4 items-center">
            <p className="text-ib-yellow-warning-dark">
              {selectedIds.length}{" "}
              {selectedIds.length > 1
                ? "fotos seleccionas"
                : "foto seleccionada"}
            </p>
            <button
              onClick={() => setSelectedIds([])}
              type="button"
              className="flex gap-2 items-center"
            >
              <span className="">Limpiar selección</span>
              <Icon name="close" className="size-4 inline-block ml-1" />
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default OptionsTableChecks;
